// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { BookmarkResponse } from "../schema";

export function serialize_BookmarkResponse_internal(value: BookmarkResponse): unknown {
  return ((value: { bookmarked: boolean }): unknown => {
    return {
      bookmarked: ((value: boolean): unknown => {
        return value;
      })(value["bookmarked"]),
    };
  })(value);
}
export function serialize_BookmarkResponse(obj: BookmarkResponse): string {
  return renderJsonWithNumbersAsBigint(serialize_BookmarkResponse_internal(obj));
}
export function deserialize_BookmarkResponse_internal(value: unknown): ParserResult<BookmarkResponse> {
  return ((
    value: unknown,
  ): ParserResult<{
    bookmarked: boolean;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/BookmarkResponse]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/BookmarkResponse]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "bookmarked")) {
      return { success: false, reason: `[#/components/schemas/BookmarkResponse/bookmarked]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bookmarked'.` };
    }
    const parsed_bookmarked = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/BookmarkResponse/bookmarked]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["bookmarked"]);
    })();
    if (!parsed_bookmarked.success) {
      return { success: false, reason: parsed_bookmarked.reason };
    }
    return { success: true, value: { bookmarked: parsed_bookmarked.value } };
  })(value);
}
export function deserialize_BookmarkResponse(str: string): ParserResult<BookmarkResponse> {
  return deserialize_BookmarkResponse_internal(parseJsonWithNumbersAsBigint(str));
}
